/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1691
 */

module.exports = "object" == typeof window
